import { ExpectedError, ServerActionResult } from './createServerAction';

/**
 * Creates a mutation wrapper for client-side usage that unwraps the result of `createServerAction`.
 * If the result contains an expected error disguised as a success, it throws an `ExpectedError`,
 * allowing React Query's `useQuery` or `useMutation` to handle it appropriately.
 */
export function createMutation<Return, Args extends unknown[]>(
  callback: (...args: Args) => Promise<ServerActionResult<Return>>
): (...args: Args) => Promise<Return> {
  return async (...args: Args): Promise<Return> => {
    const res = await callback(...args);
    if ('error' in res) throw new ExpectedError(res.error.message);
    return res.data;
  };
}
